class StayAISubscriptions extends HTMLElement {
    constructor() {
      super();
      this.productJSON = this.getAttribute("productData");
      this.product = JSON.parse(this.productJSON);
      this.productFormId = this.getAttribute("productFormId");
      this.instanceId = this.id; // Get unique instance ID
    }
  
    connectedCallback() {
      this.initWidget();
      this.setupEventListeners();
    }
  
    initWidget() {
      this.purchaseTypeSubscription = this.querySelector(
        "[for*='purchaseTypeSubscription']"
      );
      this.purchaseTypeOneTime = this.querySelector(
        "[for*='purchaseTypeOneTime']"
      );
      this.sellingPlanSelector = this.querySelector(".rtx-subscription-dropdown");
      this.subscriptionBox = this.querySelector(
        "[data-retextion-subscription-box]"
      );
      this.radioOneTime = this.querySelector(
        'input[value="purchaseTypeOneTime"]'
      );
      this.radioSubscription = this.querySelector(
        'input[value="purchaseTypeSubscription"]'
      );
      this.sellingPlanGroups = Array.isArray(this.product?.selling_plan_groups)
  ? this.product.selling_plan_groups.filter(
      (group) => String(group?.app_id) === "5859381"
    )
  : [];

this.currentVariant = Array.isArray(this.product?.variants) && this.product.variants.length
  ? this.product.variants[0]
  : null;

if (!this.currentVariant) {
  console.warn("Stay AI: no current variant found");
  return;
}

this.updateSellingPlans();
    }
  
    // Set up event listeners for the purchase type, frequency and variant selectors
    setupEventListeners() {
      const purchaseTypeRadioButtons = this.querySelectorAll(
        'input[name*="purchaseType"]'
      );
  
      // Handle purchase type change
      purchaseTypeRadioButtons.forEach((radio) =>
        radio.addEventListener("change", () => {
          // Always use the first selling plan when subscription is selected
          if (radio.value === "purchaseTypeSubscription" && this.sellingPlanSelector) {
            this.sellingPlanSelector.selectedIndex = 0;
            this.updateSellingPlanInput(this.sellingPlanSelector.value);
          } else {
            this.updateSellingPlanInput("");
          }
          
          this.updateProductPrice(
            radio.value === "purchaseTypeSubscription" ? this.sellingPlanSelector.value : ""
          );
          this.notifySellingPlanChange(
            radio.value === "purchaseTypeSubscription" ? this.sellingPlanSelector.value : ""
          );
        })
      );
  
      // Handle frequency selector change (even though it's hidden, keep for compatibility)
      if (this.sellingPlanSelector) {
        this.sellingPlanSelector.addEventListener("change", (e) => {
          this.updateSellingPlanInput(e.target.value);
          this.updateProductPrice(e.target.value);
          this.notifySellingPlanChange(e.target.value);
        });
      }
  
      // Handle variant change from external sources
      document.addEventListener('variantChange', (e) => {
        if (e.detail && e.detail.variantId) {
          const variantId = Number(e.detail.variantId);
          const newVariant = this.product.variants.find(v => v.id === variantId);
          if (newVariant) {
            this.currentVariant = newVariant;
            this.updateSellingPlans();
            // Update prices after variant change
            const isSubscription = this.isSubscriptionOptionSelected();
            const sellingPlanId = isSubscription && this.sellingPlanSelector ? this.sellingPlanSelector.value : '';
            this.updateProductPrice(sellingPlanId);
          }
        }
      });
    }
  
    // Notify external components about selling plan changes
    notifySellingPlanChange(sellingPlanId) {
      const sectionId = this.instanceId.split('-').pop(); // Extract section ID
      const event = new CustomEvent('stayAISellingPlanChange', {
        detail: {
          sellingPlanId: sellingPlanId,
          sectionId: sectionId,
          instanceId: this.instanceId
        }
      });
      document.dispatchEvent(event);
    }
  
    // Populate the subscription frequency selector with selling plans for the current variant
    updateSellingPlans() {
      // Get the selling plans for the current variant
      const stayWidget = this.querySelector(`.stay-ai-subscriptions`);
      const sellingPlans = this.currentVariant.selling_plan_allocations
        .map((spa) =>
          this.sellingPlanGroups
            .find((g) => g.id === spa.selling_plan_group_id)
            ?.selling_plans.find((sp) => sp.id === spa.selling_plan_id)
        )
        .filter(Boolean);
  
      if (sellingPlans.length == 0) {
        this.updateSellingPlanInput("");
        stayWidget.classList.toggle("is-visible", false);
        console.log("No selling plans, hiding widget");
        return;
      } else stayWidget.classList.toggle("is-visible", true);
  
      // Clear existing options and populate dropdown
      if (this.sellingPlanSelector) {
        this.sellingPlanSelector.innerHTML = sellingPlans
          .map((plan, index) => 
            `<option value="${plan.id}" ${index === 0 ? 'selected' : ''}>${plan.options[0].value}</option>`
          )
          .join("");
      }
  
      // Update selling plan input based on current selection
      if (this.isSubscriptionOptionSelected() && sellingPlans[0]) {
        this.updateSellingPlanInput(sellingPlans[0].id);
      } else {
        this.updateSellingPlanInput("");
      }
  
      // Update prices
      this.updateProductPrice(
        this.isSubscriptionOptionSelected() && sellingPlans[0]
          ? sellingPlans[0].id
          : ""
      );
    }
  
    // Check if the subscription option is selected
    isSubscriptionOptionSelected() {
      return this.purchaseTypeSubscription && this.purchaseTypeSubscription.classList.contains("is-selected");
    }
  
    //Add selling plan input to form with specified selling plan ID
    updateSellingPlanInput(sellingPlanId) {
      const productForm = document.querySelector(
        this.productFormId?.trim()
          ? `#${this.productFormId}`
          : `form[action='/cart/add'][data-type='add-to-cart-form']`
      );
  
      if (!productForm) return;
  
      // Find or create the hidden input for selling plan
      let sellingPlanInput = productForm.querySelector(
        "input[name='selling_plan']"
      );
      if (!sellingPlanInput) {
        sellingPlanInput = document.createElement("input");
        sellingPlanInput.type = "hidden";
        sellingPlanInput.name = "selling_plan";
        sellingPlanInput.value = sellingPlanId;
        productForm.appendChild(sellingPlanInput);
      } else {
        sellingPlanInput.value = sellingPlanId;
      }
      
      // Also update the dedicated selling plan input if it exists (for sections)
      const dedicatedSellingPlanInput = productForm.querySelector('.selling-plan-input');
      if (dedicatedSellingPlanInput) {
        dedicatedSellingPlanInput.value = sellingPlanId;
      }
    }
  
    updateProductPrice(sellingPlanId) {
      const selectedSellingPlanAllocation =
        this.currentVariant.selling_plan_allocations.find(
          (spa) => spa.selling_plan_id == sellingPlanId
        );
  
      const sellingPlan = this.sellingPlanGroups
        .find((group) => group.selling_plans.some((sp) => sp.id == sellingPlanId))
        ?.selling_plans.find((sp) => sp.id == sellingPlanId);
  
      const oneTimeLblPrice = this.querySelector("[data-rtx-onetime-price]");
      const subscriptionLblPrice = this.querySelector(
        "[data-rtx-subscription-price]"
      );
      const savingLbl = this.querySelector(".savings-badge");
  
      const onetimePrice = this.formatMoney(this.currentVariant.price);
      let subscriptionPrice = onetimePrice;
  
      console.log('Updating prices for variant:', this.currentVariant.id, 'Price:', onetimePrice);
  
      // Update one-time price - always use current variant price
      if (oneTimeLblPrice) {
        oneTimeLblPrice.textContent = onetimePrice;
        console.log('Updated one-time price to:', onetimePrice);
      }
  
      // Update subscription price
      if (selectedSellingPlanAllocation && this.isSubscriptionOptionSelected()) {
        subscriptionPrice = this.formatMoney(selectedSellingPlanAllocation.price);
        console.log('Found subscription price:', subscriptionPrice);
  
        if (subscriptionLblPrice) {
          // Update the subscription price display
          subscriptionLblPrice.textContent = subscriptionPrice;
          
          // Update the strikethrough price
          const fullPrice = subscriptionLblPrice.parentElement.querySelector('.fullPrice');
          if (fullPrice) {
            fullPrice.textContent = onetimePrice;
          }
        }
  
        // Calculate and update savings label
        let discount = '';
        if (sellingPlan?.price_adjustments?.[0]) {
          const adjustment = sellingPlan.price_adjustments[0];
          if (adjustment.value_type === "percentage") {
            discount = `${adjustment.value}% OFF`;
          } else {
            const savingsAmount = this.currentVariant.price - selectedSellingPlanAllocation.price;
            if (savingsAmount > 0) {
              discount = `Save ${this.formatMoney(savingsAmount)}`;
            }
          }
        }
        
        if (savingLbl && discount) {
          savingLbl.textContent = discount;
          savingLbl.style.display = 'inline-block';
        } else if (savingLbl) {
          savingLbl.style.display = 'none';
        }
      } else {
        // No subscription plan selected, show regular price
        if (subscriptionLblPrice) {
          subscriptionLblPrice.textContent = onetimePrice;
          const fullPrice = subscriptionLblPrice.parentElement.querySelector('.fullPrice');
          if (fullPrice) {
            fullPrice.textContent = onetimePrice;
          }
        }
        if (savingLbl) savingLbl.style.display = 'none';
      }
    }
  
    // Format money based on Shopify's active currency
    formatMoney(money) {
      const currencySymbols = {
        USD: "$",
        EUR: "€",
        GBP: "£",
        JPY: "¥",
        CAD: "C$",
        AUD: "A$",
        CHF: "CHF",
        CNY: "¥",
        SEK: "kr",
        NZD: "NZ$",
      };
  
      const activeCurrency = Shopify?.currency?.active || 'USD';
      const currencySymbol = currencySymbols[activeCurrency] || activeCurrency;
      const formattedMoney = (money / 100).toFixed(2).replace(".00", "");
      
      try {
        return `${currencySymbol}${formattedMoney}`;
      } catch (error) {
        console.error("Error formatting money:", error); 
        return `${currencySymbols["USD"]}${formattedMoney}`;
      }
    }
  }
  
  // Define the custom element
  if (!customElements.get("purchase-options")) {
    customElements.define("purchase-options", StayAISubscriptions);
  }